module.exports = __webpack_public_path__ + "ade3a1fa4dffca0f4976ae34687c8900.png";